export function customChartData() {
  return {
    chart: {
      title: false,
      spacingTop: 25,
      spacingBottom: 20,
      height: 260,
      backgroundColor: 'transparent'
    },
    tooltip: {
      valueDecimals: 2
    },
    plotOptions: {
      pie: {
        allowPointSelect: false,
        cursor: 'pointer',
        innerSize: '80%',
        align: 'center',
        borderColor: null,
        colors: ['#66CBE0', '#A3E0EC', '#D1EFF6', '#ED9B23', '#F4C37B', '#FBEBD3'],
        center: ['50%', '50%'],
        size: '100%',
        crop: false,
        overflow: 'auto',
        dataLabels: {
          style: {
            color: 'white',
            fontWeight: 'normal',
            textOutline: false
          }
        }
      },
      series: {
        point: {
          events: {
            click: e => this.openChartModal(e.point.name)
          }
        }
      }
    }
  }
}
